module.exports = __webpack_public_path__ + "img/inactive-subuser-img.d3537005.svg";